module.exports = __webpack_public_path__ + "img/la.c9ed6964.svg";